import css from 'styled-jsx/css';
import { colors, typography, zIndex } from '../../config/styles/index';

const SEOContentStyles = css`
  .swatch {
    position: relative;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out;
    @mixin tabletToDesktop {
      margin-left: 12px;
    }

    &-collapsed {
      overflow: hidden;
      max-height: 198px;

      @mixin desktop {
        max-height: 257px;
        border-radius: 12px;
      }

      &::after {
        position: absolute;
        bottom: 0;
        height: 163px;
        width: 100%;
        content: '';
        @mixin desktop {
          border-radius: 12px;
        }

        background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, ${colors.white.shade1} 80%);
      }
    }
    &-expanded {
      padding-bottom: 10px;
      max-height: none;
      @mixin desktop {
        border-radius: 12px;
        padding-bottom: 12px;
      }

      .description-content-text {
        padding-bottom: 40px;
      }
    }

    .showMore {
      position: absolute;
      font-size: ${typography.sm};
      font-weight: 700;
      letter-spacing: 1px;
      line-height: 15px;
      padding: 4px 24px;
      color: ${colors.gray.shade15};
      left: 0;
      right: 0;
      z-index: ${zIndex.xlp.promoShowMore};
      margin: auto;
      background-color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      @mixin tabletToDesktop {
        padding: 9px 0;
      }

      &-expandButton {
        bottom: 29px;
        @mixin tabletToDesktop {
          bottom: 23px;
        }
      }
      &-collapseButton {
        bottom: 9px;
        @mixin tabletToDesktop {
          bottom: 12px;
        }
      }

      span.label {
        text-decoration: underline;
        text-underline-offset: 3px;
      }
      span.icon-right {
        padding-left: 8px;
        font-size: ${typography.xxs1};
        font-weight: bold;
        display: flex;
        height: 8px;
        width: 8px;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .description-content-text {
    color: ${colors.gray.shade63};
    border-bottom: 1px solid ${colors.white.shade2};
    margin: 0;
    width: 100%;
    background-color: ${colors.white.shade1};
    padding: 16px;

    @mixin tabletToDesktop {
      border-radius: 12px;
    }
  }

  .description-content-text h1,
  .description-content-text h2,
  .description-content-text h3,
  .description-content-text h4,
  .description-content-text h5,
  .description-content-text h6 {
    font-weight: 700;
    margin-bottom: 10px;
    line-height: 1.5;
    color: ${colors.gray.shade64};
    letter-spacing: 0px;
    text-transform: none;
  }

  .description-content-text h1 {
    font-size: ${typography.base};
  }

  .description-content-text h2 {
    font-size: ${typography.sm1};
  }

  .description-content-text h3 {
    font-size: ${typography.sm};
  }

  .description-content-text h4 {
    font-size: ${typography.xs2};
  }

  .description-content-text h5,
  .description-content-text h6 {
    font-size: ${typography.xs};
  }

  :global(.description-content-text > h1:first-child),
  :global(.description-content-text > h2:first-child),
  :global(.description-content-text > h3:first-child),
  :global(.description-content-text > h4:first-child),
  :global(.description-content-text > h5:first-child),
  :global(.description-content-text > h6:first-child) {
    padding-bottom: 13px;
    border-bottom: 2px solid ${colors.white.shade6};
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: calc(1em + 5px);
    line-height: 2.4rem;
    text-transform: uppercase;
  }

  .description-content-text p,
  .description-content-text a {
    color: ${colors.gray.shade63};
  }
`;

export { SEOContentStyles };
